export const GenerateUuid = (): string => {
    return crypto.randomUUID();
}